<div class="row mt-2">
  <div class="col-md-3">
    <div class="card">
      <div class="card-header">
        <div class="row">
          <div class="col-md-6 text-black">Microsoft Entra ID</div>
          <div class="col-md-6">
            <span
              *ngIf="!linkedTenant"
              class="badge rounded-pill bg-danger float-end"
            >
              <i class="fa-solid fa-circle-xmark"></i>
              {{ app.getText("user.entraStatusNotConnected") }}
            </span>
            <span
              *ngIf="linkedTenant"
              class="badge rounded-pill bg-success float-end"
            >
              <i class="fa-solid fa-circle-check"></i>
              {{ app.getText("user.entraStatusConnected") }}
            </span>
          </div>
        </div>
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-md-12 align-self-center">
            <div class="row">
              <div class="col-md-12">
                <!-- Status pill -->
                <div *ngIf="!linkedTenant" class="mb-2">
                  <small>
                    {{ app.getText("user.entraStatusNotConnectedHint") }}
                  </small>
                </div>

                <div *ngIf="linkedTenant">
                  <small>
                    {{ app.getText("user.entraName") }}
                    <code class="code-text">{{
                      linkedTenant.displayName ||
                        "Tenant " + linkedTenant.tenantId
                    }}</code>
                  </small>
                  <small>
                    <p class="m-0">
                      {{ app.getText("user.entraTenantId") }}
                      <code class="code-text">{{ linkedTenant.tenantId }}</code>
                    </p>
                    <p>
                      <span *ngIf="linkedTenant.adminConsentTime">
                        {{ app.getText("user.entraConnectedOn") }}
                        <code class="code-text">{{
                          linkedTenant.adminConsentTime
                            | date : "yyyy-MM-dd HH:mm"
                        }}</code>
                      </span>
                    </p>
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <!-- Primary action -->
            <button
              *ngIf="!linkedTenant"
              class="btn btn-outline-primary btn-clean"
              type="button"
              (click)="startAdminConsent()"
            >
              <i class="fa-brands fa-microsoft"></i>
              {{ app.getText("user.entraConnectButton") }}
            </button>

            <button
              *ngIf="linkedTenant"
              class="btn btn-outline-primary btn-clean"
              type="button"
              (click)="startAdminConsent()"
            >
              <i class="fa-brands fa-microsoft"></i>
              {{ app.getText("user.entraReConnectButton") }}
            </button>
          </div>
          <div class="col-md-6 float-end">
            <button
              type="button"
              class="btn btn-outline-secondary btn-clean float-end"
              (click)="toggleEntraBenefits()"
            >
              <i class="fa-regular fa-circle-question"></i>
              {{ app.getText("user.entraHelpLink") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
